import { getLocale } from "../runtime";

const sv_buy = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Köp`
};

const buy = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_buy(inputs)
	return "buy";
};

export { buy as "buy" };